import { render } from "./ControlsLeftComponent.vue?vue&type=template&id=6247d166"
import script from "./ControlsLeftComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsLeftComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script